export const SecurityContext = {
	Host: "web_Host",
	Menu: "portal_Menu",
	RestrictByAssociation: "restrictByAssociation",
	Contact: "portal_Contact",
	Location: "portal_Menu",
	AdminGroupUser: "adminGroupUser",
	ManageUserGroup: "manage_UserGroup",
	Code: "portal_Code"
} as const;

export const SecurityContextPermission = {
	Menu: {
		Customers: "Web_Customers_Dashboard",
		NewsAndUpdates: "Web_NewsAndUpdates"
	},
	Customer: {
		Read: "Web_Customers_Read"
	},
	Location: {
		Read: "Web_Locations"
	},
	Code: {
		Read: "Web_Codes_Read",
		Write: "Web_Codes_Write"
	}
} as const;
